import React from 'react'
import { withIcon } from '../../withIcon'

function FileIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M7 3.625C6.63533 3.625 6.28559 3.76987 6.02773 4.02773C5.76987 4.28559 5.625 4.63533 5.625 5V19C5.625 19.3647 5.76987 19.7144 6.02773 19.9723C6.28559 20.2301 6.63533 20.375 7 20.375H17C17.3647 20.375 17.7144 20.2301 17.9723 19.9723C18.2301 19.7144 18.375 19.3647 18.375 19V8.625H15C14.569 8.625 14.1557 8.45379 13.851 8.14905C13.5462 7.8443 13.375 7.43098 13.375 7V3.625H7ZM14.625 4.50888L17.4911 7.375H15C14.9005 7.375 14.8052 7.33549 14.7348 7.26516C14.6645 7.19484 14.625 7.09946 14.625 7V4.50888ZM5.14384 3.14384C5.63613 2.65156 6.30381 2.375 7 2.375H14C14.1658 2.375 14.3247 2.44085 14.4419 2.55806L19.4419 7.55806C19.5592 7.67527 19.625 7.83424 19.625 8V19C19.625 19.6962 19.3484 20.3639 18.8562 20.8562C18.3639 21.3484 17.6962 21.625 17 21.625H7C6.30381 21.625 5.63613 21.3484 5.14384 20.8562C4.65156 20.3639 4.375 19.6962 4.375 19V5C4.375 4.30381 4.65156 3.63613 5.14384 3.14384Z" fill={color}/>
    </svg>
  )
}

export default withIcon(FileIcon)
